<script lang="ts">
    import { onMount } from 'svelte/internal'
    import Fa from 'svelte-fa'
    import { faAngleLeft, faClone, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    // ##############################################################################################################
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { GridBadge, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine, GridToggle } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import { QuotationEntity } from '../../../modules/posApi/quotation/quotation.entity'
    import QuotationForm from '../../pos/quotation/quotation-form.svelte'

    let show = false
    let step = 1
    let entities: QuotationEntity[] = []
    let totalModels = 999

    async function copyEntity(id: string) {
        if (!confirm('Deseja mesmo duplicar este modelo?')) return
        await window.api.tools.forms.formTemplates.copy(id)
        await loadEntities()
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await window.api.pos.quotations.getAll({ isModel: true })
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function toggleStatus(quotationId: string) {
        const current = entities.find((el) => el.quotationId === quotationId)
        await window.api.pos.quotations.update(quotationId, { status: current.status === 100 ? 70 : 100 })
        await loadEntities()
    }

    let quotationId: string = null
    function editEntity(id: string) {
        quotationId = id
        step = 2
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Modelos de Orçamento'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Ativo', type: GridColTypeEnum.toggle, size: 2 }))
        grid.cols.push(new GridCol({ content: 'Nome do modelo' }))
        grid.cols.push(new GridCol({ content: 'Data de criação', size: 2, type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        let badgeModel: GridBadge = {
            class: '',
            color: '#99999930',
            label: 'modelo',
        }
        for (const item of entities) {
            const toggle = new GridToggle({
                callback: () => {
                    toggleStatus(item.quotationId)
                },
                checked: item.status === 100,
            })
            const btnEdit = new GridButton({
                callback: () => editEntity(item.quotationId),
                icon: faEdit,
                label: 'Editar',
            })
            const btnCopy = new GridButton({
                callback: () => copyEntity(item.quotationId),
                icon: faClone,
                label: 'Duplicar',
            })
            const btns = []
            //btns.push(btnCopy)
            btns.push(btnEdit)
            let line: GridLine = new GridLine()
            line.slots.push({ content: toggle })
            line.slots.push({ content: item.title })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: btns })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await window.api.pos.quotations.remove(quotationId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    onMount(async () => {
        await loadEntities()
    })

    async function quotationFormOnCancel() {
        quotationId = null
        step = 1
    }

    async function quotationFormOnChange() {
        quotationId = null
        step = 1
        await loadEntities()
    }

    function newEntity() {
        quotationId = null
        step = 2
    }
</script>

<LoadSpinner {show}></LoadSpinner>
{#if step === 1}
    <Content>
        <div class="grid-act">
            <div class="spacer" />
            {#if window.store.token.permissions.tools.quotation.write}
                <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Novo modelo de orçamento</button>
            {/if}
        </div>
        <Zgrid class="mt-3" {grid} />
    </Content>
{/if}
{#if step === 2}
    <Content>
        <QuotationForm isModel={true} on:cancel={quotationFormOnCancel} on:change={quotationFormOnChange} {quotationId}></QuotationForm>
    </Content>
{/if}
